let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g4vOC")).then(() => parcelRequire('dScny'));